import get from "lodash/get";
import moment from "moment";

export const buildOrganizationFields = (selected) => [
  {
    name: "installation_date",
    value: get(selected, "installation_date")
      ? moment(get(selected, "installation_date")).toDate()
      : undefined,
    onSubmitValue: (value, values) =>
      value
        ? moment(value).format("YYYY-MM-DD")
        : values.installation_date_undefined
        ? null
        : undefined,
  },
  {
    name: "state_id",
    value: get(selected, "state"),
    onSubmitValue: (value) => get(value, "id"),
  },
  {
    name: "installation_date_undefined",
    value: !!get(selected, "installation_date_undefined"),
    onSubmitValue: (value) => (value ? 1 : 0),
  },
  {
    name: "restored_at",
    value: get(selected, "restored_at")
      ? moment(get(selected, "restored_at")).toDate()
      : undefined,
    onSubmitValue: (value) =>
      value ? moment(value).format("YYYY-MM-DD") : undefined,
  },
  {
    name: "restored_by",
    value: get(selected, "restored_user"),
    onSubmitValue: (value) => get(value, "id"),
  },
  {
    name: "restored_status_id",
    value: get(selected, "restored_status"),
    onSubmitValue: (value) => get(value, "id"),
  },
];

export default buildOrganizationFields;
